import { render } from "./BlogItem.vue?vue&type=template&id=c0a338f2"
import script from "./BlogItem.vue?vue&type=script&lang=js"
export * from "./BlogItem.vue?vue&type=script&lang=js"

import "./BlogItem.vue?vue&type=style&index=0&id=c0a338f2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__